import React, { useEffect, useState } from "react";
import { Form, InputNumber, Select, Input, Col, Row} from "antd";
import DividerBlock from "../divider-block";
import InputField from "../input-field";
import { FormatPrice } from "../tools/delivery-tools";
import i18n from "../../i18n";

export default function CostFields({delivery, costs, setCosts, setPrice, fieldsErrors}) {
    const [rates, setRates] = useState([]);

    const getCostErrors = (key) => {
        return (fieldsErrors && typeof fieldsErrors['cost-'+key] !== "undefined")
            ? fieldsErrors['cost-'+key][0]
            : null;
        };

    useEffect(() => {
        const newCosts = {};
        delivery.Costs.map((cost, i) => (
            newCosts[cost.Id] = {'price': 0, 'required': cost.Required, 'currencyId': cost.CurrencyId}
        ));
        setCosts(newCosts);
        setPrice(0);

        if(delivery.IsMultimodal) {
            const newRates = {};
            delivery.Multimodal.rate.map((rate, i) => (
                newRates[rate.currencyId] = rate.value
            ));
            setRates(newRates);
        }
    }, [delivery])

    const renderCosts = (costs, setCosts) => {
        const updateCost = (value, Id, Required) => {
            const newCosts = {...costs};
            newCosts[Id]['price'] = value;

            setCosts(newCosts);

            let totalPrice = 0;
            Object.keys(newCosts).forEach((el) => {
                if(Number.isInteger(newCosts[el].price)) {
                    if(newCosts[el].currencyId != 1) {
                        totalPrice += (newCosts[el].price * rates[newCosts[el].currencyId]);
                    } else {
                        totalPrice += newCosts[el].price;
                    }
                }
            });

            setPrice(Math.floor(totalPrice));
        };

        return delivery.Costs.map((cost, i) => (
            <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', padding: '5px' }} key={`cost-${i}`}>
            <Row gutter={[16, 24]} key={i + 1} >
                <Col lg={12} md={24} sm={24} sx={24}>
                    <p>{cost.Name} <b><span>{cost.CurrencySymbol}</span></b></p>
                </Col>
                <Col lg={6} md={24} sm={24} sx={24}>
                    <p>{cost.Required ? i18n.t('components.costFields.required') : ''}</p>
                </Col>
                <Col lg={6} md={24} sm={24} sx={24}>
                    <Form.Item validateStatus={getCostErrors(cost.Id) ? 'error' : ''} help={getCostErrors(cost.Id)}>
                        <InputNumber
                            min={0}
                            max={100000000}
                            name="price" label={i18n.t('components.costFields.price')}
                            size="large"
                            value={costs[cost.Id] && costs[cost.Id].price}
                            onChange={value => updateCost(value, cost.Id, cost.Required)}
                            keyNum={cost.Id}
                            style={{ width: "100%" }}
                            getFieldErrors={getCostErrors}
                        />
                    </Form.Item>
                </Col>
            </Row>
            </div >
        ));
    }

    return (
        <>
            <span className="divider-label">{i18n.t('components.costFields.divider')}</span>
            <Row gutter={[16, 24]}>
                <Col lg={24} md={24} sm={24} sx={24}>
                    <p>{delivery.CostComment}</p>
                </Col>
            </Row>
            {renderCosts(costs, setCosts)}
            <DividerBlock />
        </>
    );
}
